import { render, staticRenderFns } from "./baseCom.vue?vue&type=template&id=f9b93822&scoped=true"
import script from "./baseCom.vue?vue&type=script&lang=js"
export * from "./baseCom.vue?vue&type=script&lang=js"
import style0 from "../assets/css/base.css?vue&type=style&index=0&id=f9b93822&prod&scoped=true&lang=css&external"
import style1 from "./baseCom.vue?vue&type=style&index=1&id=f9b93822&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b93822",
  null
  
)

export default component.exports